import { PERMISSION_OBJ_DOCUMENT_IMPORT, PERMISSION_READ } from '@/constants/permissions';

import { BoardingImports } from './page';

// Sibling, not child, of `base-layout.boardings` — the page owns the entire
// base-layout outlet (same shape as waybill-imports vs waybills).
export const states = [
  {
    name: 'base-layout.boarding-imports',
    url: '/boarding-imports',
    component: BoardingImports,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_DOCUMENT_IMPORT, PERMISSION_READ]],
    },
  },
];
